<template>
  <div id="tabbar" class="tian-tabbar">
    <!-- // tabbar - height -->
    <!-- <div style="height: 100px;"></div> -->
    <div class="tian-tabbar--fixed-line"></div>

    <div class="tian-tabbar--fixed">
      <!-- <div
        class="tian-tabbar-item"
        v-for="(item,index) in tabbars"
        :key="index"
        @click="tab(index,item.name)"
      >
        <div>
          <img v-if="item.name !== 'invest'" :src="item.active_ed ? item.active : item.normal" />
          <span :class="item.active_ed ? 'active':''">{{item.title}}</span>
        </div>
      </div>-->

      <!-- tabBar s+-->
      <van-tabbar v-model="active">
        <van-tabbar-item
          active-color="#fc6524"
          inactive-color="#999db2"
          v-for="(item, index) in tabbars"
          :key="index"
          @click="tab(index, item.name)"
          class="tian-tabbar-item">
          <img
            :src="item.active_ed ? item.active : item.normal"
            style="height: 20px; width: 20px" />
          <span :class="item.active_ed ? 'active' : ''">{{ item.title }}</span>
        </van-tabbar-item>
      </van-tabbar>
      <!-- tabBar e-->
    </div>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from "vant"
import { mapGetters } from "vuex"

export default {
  name: "tianTabbar",
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  data() {
    return {
      currIndex: 0,
      active: 0,
      clickNum: 0, // 按键次数, 用来监听是否短时间内点击 tabbar 两次
      showLoading: false,
      tabbars: [
        {
          name: "home",
          title: "首页",
          active_ed: false,
          active: require("@/assets/img/home/tab-icon4.png"),
          normal: require("@/assets/img/home/tab-icon5.png")
        },
        // {
        //     name: "develop",
        //     title: "直播",
        //     active_ed: false,
        //     active: require("@/assets/img/tabbar/icon-0.png"),
        //     normal: require("@/assets/img/tabbar/icon-2.png")
        // },
        {
          name: "invest",
          title: "投资",
          active_ed: false,
          active: require("@/assets/img/home/tab-icon6.png"),
          normal: require("@/assets/img/home/tab-icon3.png")
        },
        {
          name: "news",
          title: "资讯",
          active_ed: false,
          active: require("@/assets/img/tabbar/tab_news_active.png"),
          normal: require("@/assets/img/tabbar/tab_news_normal.png")
        },
        {
          name: "user",
          title: "我的",
          active_ed: false,
          active: require("@/assets/img/home/tab-icon2.png"),
          normal: require("@/assets/img/home/tab-icon1.png")
        }
      ]
    }
  },
  created() {
    this.onTabbar()
  },
  watch: {
    $route(newVal, oldVal) {
      this.onTabbar()
    }
  },
  methods: {
    onTabbar() {
      this.tabbars.forEach((item, index) => {
        item.active_ed = false
        if (this.$route.name === item.name) {
          item.active_ed = true
        }
      })
    },

    tab(index, name) {
      this.currIndex = index
      if (!this.$route.fullPath.includes(name)) {
        this.$router.push({ name, query: { chanlCode: this.channel } })
      } else {
        this.clickNum = this.clickNum + 1
        setTimeout(() => {
          this.clickNum = 0
          this._dismissLoading()
        }, 700)
        if (this.clickNum > 1) {
          this._showLoading()
          this._onScrollyTo(0)
        }
      }
    }
  },
  computed: {
    ...mapGetters(["channel"])
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: "pang-door-right";
  src: url("../../assets/font/pang-door-right.eot");
  src: url("../../assets/font/pang-door-right.eot?#font-spider")
      format("embedded-opentype"),
    url("../../assets/font/pang-door-right.woff2") format("woff2"),
    url("../../assets/font/pang-door-right.woff") format("woff"),
    url("../../assets/font/pang-door-right.ttf") format("truetype"),
    url("../../assets/font/pang-door-right.svg") format("svg");
  font-weight: normal;
  font-style: normal;
}

.tian-tabbar {
  position: relative;
}

.tian-tabbar--fixed {
  margin-top: 50px;
  padding-top: 6px;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;

  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;

  width: 100%;
  height: 50px; // tabbar - height
  background-color: #ffffff;
}

.tian-tabbar-item {
  display: inline-block;
  // width: 33%;
  text-align: center;
  // font-size: 0;

  img {
    width: 32px;
  }

  span {
    display: block;
    color: #999db2;
  }

  span.active {
    color: #fc6524;
    // color: #fc6524;
  }

  img + span {
    margin-top: 5px;
    font-family: PingFangSC-Regular;
    // font-weight: bold;
    font-size: 12px;
    // color: #999db2;
  }
}

.tian-tabbar-item--active {
  color: #df4845;
}

.tian-tabbar-item:nth-of-type(2) {
  div {
    position: relative;
    width: 76px;
    height: 76px;
    line-height: 76px;
    background-color: #df4845;
    box-shadow: -1px 3px 4px 0 rgba(224, 79, 76, 0.75);
    top: -36px;
    border-radius: 50%;
    margin: 0 auto;
    z-index: 10;

    span {
      // font-family: 'pang-door-right';
      font-size: 12px;
      // color: #999db2;
    }
  }
}

.tian-tabbar-item:nth-of-type(3) {
  // ...
}
</style>
